import styled from 'styled-components';

export const EarlyCheckinBlockOuter = styled.div(
  props => `
    width:84.2rem;
  `,
);

export const BookEarlyOuterWrap = styled.div(
  props => ` 
    display:flex;
  `,
);

export const EarlyCheckinHeader = styled.div(
  props => `
    display: flex;
    justify-content: center;
    background-image: linear-gradient(96deg,#34393a,#adaeb2);
    color:${props.theme.colors.white.base};
    border-radius:${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
    width:10rem;
    margin-bottom: ${props.theme.spacing.large.l15};
  `,
);

export const BookEarlyTextWrap = styled.div(
  props => `
  
    color:${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font14};
    margin-right: ${props.theme.spacing.large.l15}
  `,
);

export const AddEarlyWrap = styled.a(
  props => `
    font-size:${props.theme.font.large.font14};
    cursor: pointer;
    color:${props.theme.colors.goBrand.blue};

  `,
);
